import React from "react";
import { PALETTE } from "../ThemeConstants";

export default function UserAvatar({
  background,
  color,
  borderColor,
  firstname,
  lastname,
  cover = undefined,
  shadow = true,
  size = 80,
  fontSize = 28,
  hoverable = false,
}) {
  const name = firstname.charAt(0).toUpperCase() + lastname.charAt(0).toUpperCase()
  const avatarStyle = cover ? {
    width: size,
    height: size,
    backgroundImage: `url(${cover})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundClip: "content-box",
    backgroundOrigin: "content-box",
    border: "solid 1px " + borderColor,
    borderRadius: "50%",
    boxShadow: shadow && `0 .125rem 0.25rem 0 rgb(255, 255, 255, 0.3)`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } :
    {
      width: size,
      height: size,
      background: background,
      border: "solid 1px " + borderColor,
      borderRadius: "50%",
      boxShadow: shadow && `0 .125rem 0.25rem 0 rgb(255, 255, 255, 0.3)`,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: color,
    }
  return (
    <>
      {/* Add the style element for the user-avatar class */}
      {hoverable && !cover && (
        <style>
          {`
            .user-avatar {
              background: ${background} !important;
              color: ${color} !important;
            }
            .user-avatar:hover {
              background: ${PALETTE.LINEARGRADIENT} !important;
              color: ${PALETTE.WHITE} !important;
            }
          `}
        </style>
      )}
      <div
        style={avatarStyle}
        className={`text-center align-self-center ${hoverable && "user-avatar"}`}
      >
        <span style={{ fontSize: fontSize, boxShadow: "0", height: "fit-content", width: "fit-content" }}>
          {!cover && name}
        </span>
      </div>
    </>
  );
}
